import React from "react";
import { useNavigate } from "@tanstack/react-router";
import styles from "./styles.module.css";
import { ProductCard } from "@shared/ui/ProductCard";
import { useGetTopProductsQuery } from "@entities/Shop/api/shopApiSlice";
import { Timer } from "@shared/ui/Timer";
import { useSelector } from "react-redux";
import {
  selectIsPremium,
  selectUserBalancePyl,
  selectUserRole,
} from "@entities/User/model/slice";

export const TopSkins: React.FC = () => {
  const navigate = useNavigate();
  const userPyl = useSelector(selectUserBalancePyl);
  const userPremium = useSelector(selectIsPremium);
  const userRole = useSelector(selectUserRole);
  const { data, isLoading } = useGetTopProductsQuery();

  const handleBack = () => {
    navigate({ to: "/shop/select-game" });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const sortedProducts = data?.items
    ?.filter((product) => product.position !== undefined) // Убираем товары без позиции
    ?.sort((a, b) => a.position - b.position); // Сортируем по возрастанию позиции

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <div className={styles.topHeader}>
          <button className={styles.backToGames} onClick={handleBack}>
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.14545 15.6818C8.5697 16.1061 9.25755 16.1061 9.68181 15.6818C10.1061 15.2576 10.1061 14.5697 9.68181 14.1454L3.53636 8L9.68181 1.85455C10.1061 1.4303 10.1061 0.742446 9.68181 0.318191C9.25755 -0.106064 8.5697 -0.106063 8.14545 0.318191L2 6.46364L0.463639 8L2 9.53636L8.14545 15.6818Z"
                fill="white"
              />
            </svg>
            BACK TO GAMES
          </button>
          <Timer />
        </div>

        <div className={styles.topContent}>
          <div className={styles.productsGrid}>
            {sortedProducts?.map((product) => (
              <div key={product.id} className={styles.card}>
                <ProductCard
                  id={product.id}
                  name={product.name}
                  price={product.pricePyl}
                  image={product.iconUrl}
                  isPremium={product.type === "vip"}
                  isAvable={product.isAvailable}
                  userPremium={userPremium}
                  isTypeCardPined={true}
                  userRole={userRole === "guest"}
                  position={product.position}
                  isCardPined={product.isPinned}
                  rarity={product.rarity}
                  userMoney={Number(userPyl ?? 0)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footerTop}>
          <div className={styles.footerTop__text}>
            <span className={styles.h11}>SKINS ROTATION & PIN</span>
            <span className={styles.p}>
              Список скинов обновляется каждые 24 часа. Что видишь — твой
              уникальный выбор. Скины могут закончиться — не тупи. У VIP-игроков
              есть кнопка PIN — закрепи скин, чтобы не потерять. Снял PIN и скин
              пропал? Сам виноват.
            </span>
          </div>
          <button
            className={styles.archive}
            onClick={() => navigate({ to: "/shop/select-game/archive" })}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V9.55547V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222L0 9.55547L0 1.77778ZM10.515 9.55547C10.1489 10.5912 9.16112 11.3333 8 11.3333C6.83888 11.3333 5.85109 10.5912 5.48504 9.55547H1.77778V2.66662C1.77778 2.1757 2.17575 1.77773 2.66667 1.77773H13.3333C13.8243 1.77773 14.2222 2.1757 14.2222 2.66662V9.55547H10.515Z"
                fill="white"
              />
            </svg>
            ARCHIVE
          </button>
        </div>
      </div>
    </div>
  );
};
